export enum DataHooks {
  WeekAvailability = 'week-availability',
  DayAvailability = 'day-availability',
  DayDetails = 'day-details',
  DeprecatedLoader = 'week-availability-deprecated-loader',
}
